import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useState } from 'react'
import { WalletTransactionService } from '../../services/WalletTransactionService';
import { UserWalletTransactionReferenceModelEnum } from '../../enums/UserWalletTransactionReferenceModelEnum';

let walletTransactionService = new WalletTransactionService();

function CreateWalletNegativeEntryDialog(props: any) {
  const [amount, setAmount] = useState<string>('');
  const [referenceId, setReferenceId] = useState<string>('');
  const [referenceModelName, setReferenceModelName] = useState<string>('');
  const [notes, setNotes] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  let handleClose = () => {
    setAmount('');
    setReferenceId('');
    setReferenceModelName('');
    setNotes('');
    props.callback();
  };

  const isFormValid = amount.trim() !== '' && Math.abs(Number(amount)) >= 1 && referenceId.trim() !== '' && referenceModelName !== '' && notes.trim() !== '';

  const handleCreate = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    walletTransactionService
      .createWalletNegativeEntry(props?.userId, amount, Number(referenceId), referenceModelName, notes)
      .then(() => handleClose())
      .catch((err) => console.log(err))
      .finally(() => setIsSubmitting(false));
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      scroll={"paper"}
      maxWidth="xl"
    >
      <DialogTitle>Create Wallet Negative Entry</DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Grid
            container
            spacing={2}
            justifyContent={"space-evenly"}
            style={{ padding: "12px 12px 12px 12px" }}
            direction="column"
            alignItems="center"
          >
            <Grid item xs={12}>
              <FormControl style={{ width: 500 }}>
                <TextField
                  label="Enter Amount"
                  value={amount}
                  required
                  onChange={(e) => setAmount(e.target.value)}
                  error={amount.trim() !== '' && Math.abs(Number(amount)) < 1}
                  helperText={amount.trim() !== '' && Math.abs(Number(amount)) < 1 ? 'Amount must be ≥ 1 or ≤ -1 (e.g. 1.1, -1.2)' : ''}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl style={{ width: 500 }}>
                <InputLabel id="reference-model-label">Reference Model *</InputLabel>
                <Select
                  labelId="reference-model-label"
                  value={referenceModelName}
                  label="Reference Model *"
                  required
                  onChange={(e) => setReferenceModelName(e.target.value)}
                >
                  <MenuItem value={UserWalletTransactionReferenceModelEnum.ONE_MEAL_SERVICE}>
                    {UserWalletTransactionReferenceModelEnum.ONE_MEAL_SERVICE}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl style={{ width: 500 }}>
                <TextField
                  label="Reference ID"
                  type="number"
                  value={referenceId}
                  required
                  onChange={(e) => setReferenceId(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl style={{ width: 500 }}>
                <TextField
                  label="Notes"
                  value={notes}
                  required
                  onChange={(e) => setNotes(e.target.value)}
                />
              </FormControl>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleCreate} size={"large"} disabled={!isFormValid || isSubmitting}>
          {isSubmitting ? 'Creating...' : 'Create'}
        </Button>
        <Button variant="contained" color={"error"} onClick={handleClose} size={"large"}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateWalletNegativeEntryDialog;